// ---------------- Start External Library Import --------------------//
/* eslint-disable  */
import React from 'react';
import PropTypes from 'prop-types';
import SigninPreOTPPage from '@techsoftware/happay-widgets/SignInPreOTPPage';
import SigninPostOTPPage from '@techsoftware/happay-widgets/SignInPostOTPPage';
import Recaptcha from 'react-google-recaptcha';
import history from '../../utils/history';

export default class SignInWithOtp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sitekey: this._checksiteKey(),
      response: '',
      // showOtpTab: false,
      // OTPSent: LoginStore._getField("otp"),
      // userId: LoginStore._getField("userId")
    };
    this.recaptchaInstance = '';
    // this._otpRecieve = this._otpRecieve.bind(this);
  }

  componentDidMount() {
    const { loginInfo } = this.props;
    if (!loginInfo.value) {
      history.push('/login');
    }
  }

  componentWillUnmount(){
    this.props.otpSent(false);
  }

  _checksiteKey() {
    const { origin } = window.location;

    if (
      [
        'https://localhost:8080',
        'https://v2-uat.happay.in',
        'https://expense-uat.happay.in',
        'https://bills.uat.happay.in',
        'file://',
        'https://dc0hc3otlytmh.cloudfront.net',
        'http://3.210.31.248:8005',
        'https://expense-prep.happay.in',
      ].indexOf(origin) !== -1
    ) {
      return '6LdL7T8UAAAAAMxVRrPW8hqpAHWMtRCE2TSDSfuO';
    }
    if (origin === 'https://expense.happay.in') {
      return '6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL';
    }
    return '6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL';
  }

  onChangeCaptcha(captchaValue) {
    const { value, code, activeTab } = this.props.loginInfo;
    const temp = {
        ...(activeTab === 1 ? { mobile_number: value } : { email_id: value }),
        mobile_extension: code,
        response: captchaValue
    };
    this.setState(
        {
            response: captchaValue
        },
        () => this.onSignIn(temp)
    );
}

  // _otpRecieve() {
  //     let { response } = this.state;
  //     this.setState({
  //         OTPSent: LoginStore._getField("otp"),
  //         showOtpTab: response ? true : false
  //     });
  // }
  renderGoogleCaptcha() {
    return (
      <Recaptcha
        ref={e => (this.recaptchaInstance = e)}
        className="g-recaptcha"
        sitekey={this.state.sitekey}
        onChange={this.onChangeCaptcha.bind(this)}
      />
    );
  }

  onSignIn = value => {
    const { response } = this.state;
    const { loginInfo, OTPSent } = this.props;
    const data = {};
    if (!OTPSent) {
      data.mobile_number = value.mobile_number;
      data.email_id = value.email_id;
      data.mobile_extension = loginInfo.code;
      data.response = response;
      this.props.sendOTP(data);
    } else {
      data.user = value.user;
      if (value.mobile_extension) {
        data.mobile_extension = value.mobile_extension;
      }
      data.otp = value.otp;
      if (loginInfo.userId) {
        data.user_id = loginInfo.userId;
      }
      this.props.onLogin(data);
    }
  };

  _handleGoBack = () => {
    this.setState({
      response: '',
    });
  };

  render() {
    const { response } = this.state;
    const {
      productLogo,
      privacyPolicyUrl,
      termOfUseUrl,
      loginInfo,
      OTPSent,
    } = this.props;
    return (
      <div>
        {OTPSent && response ? (
          <SigninPostOTPPage
            containerClassName="signin-container"
            logo={productLogo}
            // breakPoints={breakPoints}
            // onClickBack={() => {
            //   history.goBack();
            // }}
            onSignIn={this.onSignIn}
            onClickBack={this._handleGoBack}
            data={loginInfo}
            privacyPolicyUrl={privacyPolicyUrl}
            termOfUseUrl={termOfUseUrl}
            privacyPolicyText="Privacy Policy"
            termOfUseText="Terms of Use"
            // postOtpHeader={i18n.t("placeholder.enterOtp")}
            // backButtonText={i18n.t("btn.back")}
            // signInButtonText={i18n.t("btn.signIn")}
            // postOtpSubHeaderOne={i18n.t("flexi.yourOtpHasBeenSent")}
            // postOtpSubHeaderTwo={i18n.t("flexi.pleaseEnterSign")}
            // otpFloatingLabelText={i18n.t("lbl.otp")}
            // otpHintText={i18n.t("lbl.enterOTP")}
            // otpValidationStr={i18n.t("err.otpCannotBeEmpty")}
          />
        ) : (
          <SigninPreOTPPage
            containerClassName="signin-container"
            logo={productLogo}
            // breakPoints={breakPoints}
            onSignIn={this.onSignIn}
            onClickBack={() => {
              history.goBack();
            }}
            disableButton={response === ''}
            googleCaptcha={this.renderGoogleCaptcha()}
            data={loginInfo}
            privacyPolicyUrl={privacyPolicyUrl}
            termOfUseUrl={termOfUseUrl}
            privacyPolicyText="Privacy Policy"
            termOfUseText="Terms of Use"
            // preOtpHeader={i18n.t("logIn.enterCaptcha")}
            // backButtonText={i18n.t("btn.back")}
            // getOtpButtonText={i18n.t("logIn.getOtp")}
          />
        )}
      </div>
    );
  }
}

SignInWithOtp.propTypes = {
  sendOTP: PropTypes.func,
  onLogin: PropTypes.func,
  productLogo: PropTypes.node,
  privacyPolicyUrl: PropTypes.string,
  termOfUseUrl: PropTypes.string,
  loginInfo: PropTypes.object,
  OTPSent: PropTypes.bool,
};

SignInWithOtp.defaultProps = {
  OTPSent: '',
};
